var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Bulk/Edit"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Edit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    opacity: 0.4,
    d: "M19.9927 18.9531H14.2984C13.7429 18.9531 13.291 19.4121 13.291 19.9765C13.291 20.5419 13.7429 20.9999 14.2984 20.9999H19.9927C20.5483 20.9999 21.0001 20.5419 21.0001 19.9765C21.0001 19.4121 20.5483 18.9531 19.9927 18.9531Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    d: "M10.309 6.90263L15.7049 11.2627C15.835 11.367 15.8573 11.5583 15.7557 11.6916L9.35874 20.027C8.95662 20.5419 8.36402 20.8332 7.72908 20.844L4.23696 20.887C4.05071 20.8891 3.88775 20.7601 3.84542 20.5752L3.05175 17.1245C2.91419 16.4903 3.05175 15.8346 3.45388 15.3293L9.88256 6.95423C9.98627 6.81986 10.1778 6.79621 10.309 6.90263Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-5",
    opacity: 0.4,
    d: "M18.1213 8.66544L17.081 9.96401C16.9763 10.0962 16.7879 10.1177 16.6578 10.0124C15.3932 8.98901 12.155 6.36285 11.2566 5.63509C11.1254 5.52759 11.1074 5.33625 11.2132 5.20295L12.2164 3.95706C13.1265 2.78534 14.7138 2.67784 15.9942 3.69906L17.4652 4.87078C18.0684 5.34377 18.4705 5.96726 18.6081 6.62299C18.7668 7.3443 18.5975 8.0527 18.1213 8.66544Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.217caca26f8d95c9379ae6bcf57440cb.svg";
export { ForwardRef as ReactComponent };